import React, {useEffect, useState} from "react";
// Custom component
import Layout from "../../components/common/layout";
// Api
import {getContentList} from "../../services/contentservice";
// third party
import toast from "react-hot-toast";
import {marked} from "marked";
import {Container, Row} from "react-bootstrap";

const TermsAndCondition = () => {
    const [termsNCon, setTermsNCon] = useState();

    /**
     * @function fetchContentList
     * @param
     * @description get content List
     */
    const fetchContentList = async () => {
        try {
            const result = await getContentList();
            if (result?.data?.data) {
                setTermsNCon(result?.data?.data?.terms_condition);
            } else {
                setTermsNCon();
                toast.error(result?.response?.data?.message || "Something went wrong");
            }
        } catch (error) {
            setTermsNCon();
            toast.error(error || error?.response?.data?.message || "Something went wrong");
        }
    };

    useEffect(() => {
        fetchContentList();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        document.title = "Terms | Play Sports Together";
    }, []);

    return (
        <Layout>
            <Container className="px-0 px-sm-5 my-5">
                <Row className="px-5 mx-0">
                    {termsNCon && <div dangerouslySetInnerHTML={{__html: marked(termsNCon)}} />}
                </Row>
            </Container>
        </Layout>
    );
};

export default TermsAndCondition;
